export var DobSource;
(function (DobSource) {
    DobSource["PROVE"] = "p";
    DobSource["BLUECHECK"] = "b";
    DobSource["AGECHECKED"] = "a";
})(DobSource || (DobSource = {}));
